import { gunterzBold } from '@/theme/fonts';
import { AspectRatio, Card, Flex, Image, Stack, Text } from '@mantine/core';
import Link from 'next/link';
import classes from './SearchCategoryItem.module.css';
import type { CategoryItem } from './data';
export const SearchCategoryItem: React.FC<CategoryItem> = ({
  ...props
}) => {
  return <Card component={Link} href={props.url} radius={5} p={{
    base: 8,
    sm: 14
  }} w={{
    base: 'auto',
    sm: 154,
    lg: 150
  }} h={{
    base: '100%',
    sm: 100,
    lg: 175
  }} mod={{
    active: props.active
  }} className={classes.card}>
      <Flex direction={{
      base: 'row',
      sm: 'column'
    }} justify={{
      base: 'start',
      sm: 'center'
    }} align="center" gap={{
      base: 8,
      sm: 10,
      lg: 12
    }}>
        <AspectRatio ratio={1 / 1}>
          <Image src={props.imgUrl} mx="auto" w={{
          base: 36,
          md: 80,
          lg: 100
        }} h={{
          base: 36,
          md: 80,
          lg: 100
        }} />
        </AspectRatio>
        <Stack gap={0}>
          <Text lh="xs" ta="center" className={gunterzBold.className} fz={{
          base: 11,
          sm: 14,
          md: 13
        }} variant={props.isGradient ? 'gradient' : 'text'} gradient={{
          from: `${props.colorFrom}`,
          to: `${props.colorTo}`,
          deg: 135
        }} style={{
          textWrap: 'nowrap'
        }}>
            {props.text}
          </Text>
          {props.subText?.length && <Text span ta={{
          base: 'left',
          sm: 'center'
        }} fz={10} c={props.subTextColor}>
              {props.subText}
            </Text>}
        </Stack>
      </Flex>
    </Card>;
};